interface SpacingsProps {
    name: string;
    value: string;
}
const spacings: SpacingsProps[] = [
    {
        name: '0',
        value: 'var(--spacing-0, 0rem)',
    },
    {
        name: '0.5',
        value: 'var(--spacing-0-5, 0.125rem)',
    },
    {
        name: '1',
        value: 'var(--spacing-1, 0.25rem)',
    },
    {
        name: '1.5',
        value: 'var(--spacing-1-5, 0.375rem)',
    },
    {
        name: '2',
        value: 'var(--spacing-2, 0.5rem)',
    },
    {
        name: '3',
        value: 'var(--spacing-3, 0.75rem)',
    },
    {
        name: '4',
        value: 'var(--spacing-4, 1rem)',
    },
    {
        name: '5',
        value: 'var(--spacing-5, 1.25rem)',
    },
    {
        name: '6',
        value: 'var(--spacing-6, 1.5rem)',
    },
    {
        name: '8',
        value: 'var(--spacing-8, 2rem)',
    },
    {
        name: '12',
        value: 'var(--spacing-12, 3rem)',
    },
    {
        name: '16',
        value: 'var(--spacing-16, 4rem)',
    },
    {
        name: '24',
        value: 'var(--spacing-24, 6rem)',
    },
    {
        name: '32',
        value: 'var(--spacing-32, 8rem)',
    },
];

export default spacings;
